import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import * as Sentry from "@sentry/react";
import './App.css';

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  useEffect(() => {
    Sentry.captureMessage(`capture Error Page ${error.statusText || error.message}`);
  }, []);

  return (
    <div id="error-page" className="app">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}